import PropTypes from 'prop-types';
import styled from 'helpers/styles';
import ComponentStyles from 'styles/mixins/Component.styles';
import List from 'components/atoms/Lists/List/List';
import {rgba} from 'polished';

const StyledUserList = styled(List)`
  &.UserList {
    .ListItemButton {
      gap: ${props => props.theme.layout('1sp')};
      padding: ${props => props.theme.spacing(1)} ${props => props.theme.spacing(2)} ${props => props.theme.spacing(1)} ${props => props.theme.spacing(1.5)};

      > .Typography {
        flex-grow: 1;
      }

      > .Icon {
        margin-right: ${props => props.theme.layout('-0.5sp')};
      }
    }
  }
  
  .UserList {
    &-empty {
      width: 100%;
      text-align: center;
      color: ${props => rgba(props.theme.property('palette.text.primary'), props.theme.property('palette.action.disabledOpacity'))};
      font-style: italic;

      > .Typography {
        padding: ${props => props.theme.spacing(1)} ${props => props.theme.spacing(2)} ${props => props.theme.spacing(1)} ${props => props.theme.spacing(1.5)};
      }
    }
  }
  
  ${ComponentStyles}
`;

StyledUserList.propTypes = {
  theme: PropTypes.object
};

export default StyledUserList;
